module.exports = __webpack_public_path__ + "static/media/stb_stx.e505a2a1.pdf";